export type DashboardGridChrome = 'compact' | 'standard' | 'embedded';

const CHROME_OFFSET_PX: Record<DashboardGridChrome, number> = {
  compact: 220,
  standard: 300,
  embedded: 200,
};

const DASHBOARD_GRID_MIN_HEIGHT_PX = 240;
const DASHBOARD_GRID_HEADER_HEIGHT_PX = 56;

/** Height for virtualized grids inside a flex-filled dashboard page body. */
const DASHBOARD_GRID_FILL_HEIGHT = '100%';

export function useDashboardGridScrollHeight(_chrome: DashboardGridChrome = 'standard'): string {
  return DASHBOARD_GRID_FILL_HEIGHT;
}

export const DASHBOARD_GRID_ROW_HEIGHT = 52;

export function getDashboardGridContentHeightPx(rowCount: number): number {
  if (rowCount === 0) {
    return DASHBOARD_GRID_HEADER_HEIGHT_PX + DASHBOARD_GRID_ROW_HEIGHT;
  }
  return DASHBOARD_GRID_HEADER_HEIGHT_PX + rowCount * DASHBOARD_GRID_ROW_HEIGHT;
}

function getDashboardGridMaxHeightPx(chrome: DashboardGridChrome): number {
  if (typeof window === 'undefined') {
    return DASHBOARD_GRID_MIN_HEIGHT_PX;
  }
  return Math.max(DASHBOARD_GRID_MIN_HEIGHT_PX, window.innerHeight - CHROME_OFFSET_PX[chrome]);
}

/** True when all rows fit in the viewport; table should shrink instead of filling it. */
export function shouldUseCompactDashboardGridHeight(
  rowCount: number,
  chrome: DashboardGridChrome,
): boolean {
  return getDashboardGridContentHeightPx(rowCount) <= getDashboardGridMaxHeightPx(chrome);
}
